import { globalState } from "../inference/globals.js";
import toothClasses from "../../data/tooth_classes.json";
import defectClasses from "../../data/defect_classes.json";
import { encodeRunLength } from "./encoding.js";

// Function to create labels JSON from the inference result
function createLabelsJSON(neededFields = null) {
    if (
        !globalState.lastInferenceResult ||
        !globalState.lastInferenceResult.labels
    ) {
        return null;
    }

    // Create JSON file with labels in the format described in dataset_format.md
    const processingMode =
        document.getElementById("processing-mode-dropdown")?.value || "teethml";
    const classesData =
        processingMode === "defectml" ? defectClasses : toothClasses;

    // Get unique classes and instances in the result
    const uniqueClasses = new Set(globalState.lastInferenceResult.labels);

    // Encode labels and instance_ids using run-length encoding
    const labelsData = globalState.lastInferenceResult.labels;
    const instanceIdsData =
        globalState.lastInferenceResult.instance_ids ||
        globalState.lastInferenceResult.labels;

    // Create base JSON content
    const result = {
        version: "1.0",
        is_compressed: true
    };

    // If neededFields is provided, only include those fields
    // Otherwise include all fields
    const includeField = (field) =>
        !neededFields || neededFields.includes(field);

    // Add fields based on selection
    if (includeField("labels")) {
        result.labels = {
            encoding: "runlength",
            data: encodeRunLength(labelsData)
        };
    }

    if (includeField("instance_ids")) {
        result.instance_ids = {
            encoding: "runlength",
            data: encodeRunLength(instanceIdsData)
        };
    }

    if (includeField("class_ids")) {
        result.class_ids = Array.from(uniqueClasses);
    }

    if (includeField("class_names")) {
        result.class_names = Array.from(uniqueClasses).map((classId) => {
            const classData = classesData.find(
                (c) => c.id === parseInt(classId)
            );
            return classData ? classData.name : `Unknown (${classId})`;
        });
    }

    if (includeField("class_colors")) {
        result.class_colors = Array.from(uniqueClasses).map((classId) => {
            const classData = classesData.find(
                (c) => c.id === parseInt(classId)
            );
            return classData ? classData.color : "#FFFFFF";
        });
    }

    if (
        includeField("boundary_points") &&
        globalState.lastInferenceResult.boundary_points
    ) {
        result.boundary_points =
            globalState.lastInferenceResult.boundary_points;
    }

    if (
        includeField("simplified_boundary_points") &&
        globalState.lastInferenceResult.simplified_boundary_points
    ) {
        result.simplified_boundary_points =
            globalState.lastInferenceResult.simplified_boundary_points;
    }

    return result;
}

export { createLabelsJSON };
